
<div class="row">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
      <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="font-familyhead">Cryo Preservation</label>
            <qrcode class="padding-top-0px padding-bottom-0px qr-style6" [qrdata]="FormattedCode" [size]="90" [level]="'M'"></qrcode>
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{Owner}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Gender}}/{{Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{FormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Infertility Type:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Infertility}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Donor:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorData}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Cycle:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{CycleType}} ({{CycleNo}})</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocol}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol Start:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Protocolst | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Protocol End:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{ProtocolEd | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="EggSourceData=='DONOR' || EggSourceData=='Donor'">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Donor ID:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{DonorCode}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-bold">Embryo Storage Table</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">

            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">

                    <tr>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        Sno
                      </th>

                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        DOC
                      </th>
                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Date
                      </th>
                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Grade
                      </th>
                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        Stage
                      </th>

                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Embryo To Freeze
                      </th>
                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Freeze Count
                      </th>
                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Storage
                      </th>

                    </tr>

                    <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleController ; let RowIndex = index">

                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.DOC}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        <label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}}</label>
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        <label class="margin-bottom-0px" *ngIf="l.DOC!=='3'">{{l.CellStage}}</label>
                        <label class="margin-bottom-0px" *ngIf="l.DOC=='3'">{{l.CellCount}}</label>
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.FrozenCount}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">0</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center"></td>
                    </tr>

                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-bold">Current Cycle</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">

            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">

                    <tr>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        Sno
                      </th>

                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Cycle Details
                      </th>
                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        DOC
                      </th>
                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Date
                      </th>
                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        Grade
                      </th>

                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Stage
                      </th>
                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Embryo Count
                      </th>

                    </tr>

                    <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferrablesController ; let RowIndex = index">

                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.CycleNumber}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.DOC}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        <label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}} </label>
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        <label class="margin-bottom-0px" *ngIf="l.DOC!=='3'">{{l.CellStage}}</label>
                        <label class="margin-bottom-0px" *ngIf="l.DOC=='3'">{{l.CellCount}}</label>
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.EmbryoCount}}</td>

                    </tr>

                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-bold">Previous Cycle</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">

            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">

                    <tr>

                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        Sno
                      </th>

                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Cycle Details
                      </th>
                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        DOC
                      </th>
                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Date
                      </th>
                      <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                        Grade
                      </th>

                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Stage
                      </th>
                      <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                        Embryo Count
                      </th>

                    </tr>

                    <tr *ngFor="let l of CurrentIvfCycleEmbryoTransferrablesControllerByActor ; let RowIndex = index">

                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.CycleNumber}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.DOC}}</td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        {{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        <label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}} </label>
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">
                        <label class="margin-bottom-0px" *ngIf="l.DOC!=='3'">{{l.CellStage}}</label>
                        <label class="margin-bottom-0px" *ngIf="l.DOC=='3'">{{l.CellCount}}</label>
                      </td>
                      <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.EmbryoCount}}</td>

                    </tr>

                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</div>

